module.exports = __webpack_public_path__ + "media/4x3/fr-81d43a15.svg";